var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 89,
    viewBox: "0 0 118 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9511 62.9346H41.0439V82.7488H50.9511V62.9346Z",
    fill: "#5F687A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8 88H25.2C23.8209 88 22.4982 87.5786 21.523 86.8284C20.5479 86.0783 20 85.0609 20 84C20 82.9391 20.5479 81.9217 21.523 81.1716C22.4982 80.4214 23.8209 80 25.2 80H66.8C68.1791 80 69.5018 80.4214 70.477 81.1716C71.4521 81.9217 72 82.9391 72 84C72 85.0609 71.4521 86.0783 70.477 86.8284C69.5018 87.5786 68.1791 88 66.8 88Z",
    fill: "#5F687A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5573 0H5.26808C2.3586 0 0 2.33964 0 5.22574V62.7089C0 65.595 2.3586 67.9346 5.26808 67.9346H89.5573C92.4668 67.9346 94.8254 65.595 94.8254 62.7089V5.22574C94.8254 2.33964 92.4668 0 89.5573 0Z",
    fill: "#6FABE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79 30.8023C79 28.161 81.1538 26 83.7863 26H112.504C115.136 26 117.29 28.161 117.29 30.8023V83.6274C117.29 86.2687 115.136 88.4297 112.504 88.4297H83.7863C81.1538 88.4297 79 86.2687 79 83.6274V30.8023Z",
    fill: "#C5D4F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79 30.8023C79 28.161 81.1538 26 83.7863 26H112.504C115.136 26 117.29 28.161 117.29 30.8023V38.0057H79V30.8023ZM117.29 83.6274C117.29 86.2687 115.136 88.4297 112.504 88.4297H83.7863C81.1538 88.4297 79 86.2687 79 83.6274V76.424H117.29V83.6274Z",
    fill: "#5F687A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0931 83.731C99.4244 83.731 100.504 82.6568 100.504 81.3317C100.504 80.0067 99.4244 78.9325 98.0931 78.9325C96.7618 78.9325 95.6826 80.0067 95.6826 81.3317C95.6826 82.6568 96.7618 83.731 98.0931 83.731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesIcon);
export default __webpack_public_path__ + "static/media/devices-icon.ee89ef14968b6b13fc994e625b177547.svg";
export { ForwardRef as ReactComponent };